import { jsx as o } from "react/jsx-runtime";
import { ListBoxSelect as b, Tooltip as u } from "@systemeio/ui";
import { useEditorState as m } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as f } from "react";
import { ToolbarSelectButton as d } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as c } from "../../constants/default-styles.mjs";
import { useTranslation as h } from "../../i18n.mjs";
const L = (l, r) => {
  const { t: i } = h(), a = r == null ? void 0 : r.substitutions, n = m({
    editor: l,
    selector: ({ editor: s }) => ({
      isEditable: (s == null ? void 0 : s.options.editable) ?? !1
    })
  }), t = !(n != null && n.isEditable);
  return f(() => {
    const s = (e) => {
      if (!l) return null;
      e && l.chain().focus().insertContent(e).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ o(
        b,
        {
          value: void 0,
          disabled: t,
          data: a,
          onChange: s,
          children: (e) => /* @__PURE__ */ o(
            u,
            {
              disabled: t,
              label: i("substitute_variables"),
              anchor: "left",
              ...c,
              children: /* @__PURE__ */ o(d, { open: e, disabled: t, children: i("substitutions") })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ o(
        b,
        {
          optionsClassName: "z-40",
          value: void 0,
          disabled: t,
          data: a,
          onChange: s,
          children: (e) => /* @__PURE__ */ o(
            u,
            {
              disabled: t,
              label: i("substitute_variables"),
              anchor: "left",
              ...c,
              children: /* @__PURE__ */ o(d, { open: e, disabled: t, children: i("substitutions") })
            }
          )
        }
      )
    };
  }, [l, t, a, i]);
};
export {
  L as useSubstitutesExtensionToolbar
};
